import { Component, OnInit,ViewChild} from '@angular/core';
import { FormBuilder } from '@angular/forms';


@Component({
  selector: 'app-modaltest',
  templateUrl: './modaltest.component.html',
  styleUrls: ['./modaltest.component.css']
})
export class ModaltestComponent implements OnInit {

  showModal = false;


  constructor(private fb: FormBuilder) { }
  ngOnInit() {

  }



}
